import { gql } from 'urql'

export const fetchProjectYearlyReportsKpi = gql`
  query fetchProjectYearlyReportsKpi(
    $projectBaseWhere: project_base_bool_exp!
    $featureConfigKPIWhere: jsonb_comparison_exp!
    $language: String!
    $featureTypeSortingConfig: feature_type_sorting_config_bool_exp!
    $featureGroupSortingConfig: feature_group_sorting_config_bool_exp!
    $featureSortingConfig: feature_sorting_config_bool_exp!
  ) {
    feature_config(
      where: {
        _and: {
          has_kpi_for_processes: $featureConfigKPIWhere
          feature_values: { feature_base: { project_base: $projectBaseWhere } }
        }
      }
    ) {
      names(path: $language)
      tooltips(path: $language)

      feature_sorting_configs(where: $featureSortingConfig, order_by: { sort_order: asc }) {
        sort_order
      }

      feature_group_config {
        feature_group_sorting_configs(where: $featureGroupSortingConfig, order_by: { sort_order: asc }) {
          sort_order
        }
      }

      feature_type_config {
        names(path: $language)
        feature_type_sorting_configs(where: $featureTypeSortingConfig, order_by: { sort_order: asc }) {
          sort_order
        }
      }

      feature_values {
        other_description
      }

      feature_kpi_annual_reports(
        where: {
          _and: { milestone: { dossier: { project_bases: $projectBaseWhere } }, annual_value: { _is_null: false } }
        }
        order_by: { milestone: { year_in_focus: asc } }
      ) {
        annual_value

        feature_config {
          names(path: $language)
          tooltips(path: $language)

          feature_type_config {
            names(path: $language)
          }

          feature_values {
            other_description
          }
        }

        milestone {
          year_in_focus
        }
      }
    }
  }
`
